var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_vm._v(" 2024 © EasySaude 1.0. ")]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"text-sm-right d-none d-sm-block"},[_vm._v(" SiD Soluções ")])])])])])
}]

export { render, staticRenderFns }